import React from 'react';
import { View, Text, TouchableHighlight } from 'react-native';
import { useDispatch } from 'react-redux';
import {
  WorkoutContainerHeaderTwo,
  WorkoutContainerHeaderThree,
  WorkoutContainerText,
  WorkoutTextHeader,
  WorkoutCommonButton,
  WorkoutButtonTwo,
} from '../styles/common-styles';
import { logoutUser } from '../reducers/cbcAuthorizationSlice';
import Bugsnag from "@bugsnag/expo";
import styled from "styled-components/native";

function SettingsBar({ navigation }) {
  const dispatch = useDispatch();

  async function logOut() {
    Bugsnag.leaveBreadcrumb('User logging out.');
    await dispatch(logoutUser());
    navigation.reset({
      index: 0,
      routes: [{ name: 'login' }], // The name of the login route
    });
  }

  return (
      <SettingsBarParent>
        <TouchableHighlight onPress={() => logOut()}>
          <WorkoutContainerText
              style={{ color: '#282F63', textDecorationLine: 'underline' }}
          >
            LOGOUT
          </WorkoutContainerText>
        </TouchableHighlight>
      </SettingsBarParent>
  );
}

export const SettingsBarParent = styled.View`
  height: 45px;
  left:20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: #ffffff;
`;

export default SettingsBar;
